var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20C7.91015 20 5 17.0899 5 13.5C5 9.91015 7.91015 7 11.5 7C14.9344 7 17.7468 9.66365 17.9838 13.0378C18.1523 13.0129 18.3246 13 18.5 13C20.433 13 22 14.567 22 16.5C22 18.433 20.433 20 18.5 20H11.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50098 13.6267C2.59369 14.2591 2 15.3102 2 16.5C2 18.433 3.567 20 5.5 20C5.88408 20 6.2537 19.9381 6.59946 19.8238C4.74466 18.3844 3.5401 16.1469 3.50098 13.6267Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAlt);
export default __webpack_public_path__ + "static/media/cloud-alt.f3c52180a347db234a6c742fd9a03846.svg";
export { ForwardRef as ReactComponent };